import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window + main scroll container to top on every route change.
 * Place inside <BrowserRouter> so useLocation works.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset window scroll
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // Reset any inner scrollable main containers (MainLayout uses overflow-y-auto on <main>)
    document.querySelectorAll<HTMLElement>("main, [data-scroll-container]").forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
